export class ReadReviewsClickedUseCase {
    public execute = () => {
        // This class name is being passed by the Drupal file sd_spp_reviews_v1.mustache
        const reviewsSection = document.querySelector('.js-product-reviews');

        if (reviewsSection) {
            reviewsSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    };
}
